import { useTranslator } from '@eo-locale/preact';
import { ExtendedTopRatedProductsWidgetSettings } from 'types/settings';

import { useSettings } from 'components/SettingsProvider';
import { Slider } from 'components/Slider';

import { Slide } from './components/Slide';

import slideStyles from './components/Slide/Slide.module.scss';

interface TopRatedProductsWidgetProps {
  onRemove: () => void;
}

export function TopRatedProductsWidget({
  onRemove,
}: TopRatedProductsWidgetProps) {
  const { translate } = useTranslator();
  const { total_products, products_demo, products } =
    useSettings<ExtendedTopRatedProductsWidgetSettings>();

  let product_list = [...products];

  if (product_list.length === 0) {
    if (Shopify.designMode) {
      product_list = [...products_demo];
    } else {
      onRemove();
    }
  }

  product_list.sort((a, b) => {
    const ratingA = a.overall_rating ? a.overall_rating : 0;
    const ratingB = b.overall_rating ? b.overall_rating : 0;

    return ratingB - ratingA;
  });

  if (product_list.length > total_products) {
    product_list.length = total_products;
  }

  const slidesMarkup = product_list.map(
    ({
      id,
      title,
      handle,
      image_src,
      overall_rating,
      reviews_count,
      price,
      url,
    }) => {
      return (
        <Slide
          key={id}
          product={{
            id,
            title,
            handle,
            image_src,
            overall_rating,
            reviews_count,
            price,
            url,
          }}
        />
      );
    },
  );

  return (
    <Slider
      slidesCount={product_list.length}
      slidesPerView={4}
      heading={translate('widget_top_rated_products_title', {
        defaultMessage: 'Our top rated products',
      })}
      slideSelector={slideStyles.VerticalSlide}
      minSlideWidth={180}
      maxSlideWidth={300}
    >
      {slidesMarkup}
    </Slider>
  );
}
